import { RootState } from '../../../store';

export const getActivityLogs = (state: RootState) => state.activityLog.activityLogs;
export const getActivityLogPagination = (state: RootState) => state.activityLog.pagination;
export const getIsActivityLogsLoading = (state: RootState) => state.activityLog.isLoading;
export const getLoggableActionTypes = (state: RootState) => state.activityLog.loggableActionTypes;
